// extracted by mini-css-extract-plugin
export var circle = "_3z-2";
export var icon = "_3z-a";
export var iconHighlight = "_3z-0";
export var lg = "_3z-8";
export var md = "_3z-7";
export var outline = "_3z-4";
export var sm = "_3z-6";
export var square = "_3z-1";
export var xl = "_3z-9";
export var xs = "_3z-5";
export var xxs = "_3z-3";